import { render } from "./YonrinHeader.vue?vue&type=template&id=5edeee74&scoped=true&ts=true"
import script from "./YonrinHeader.vue?vue&type=script&lang=ts"
export * from "./YonrinHeader.vue?vue&type=script&lang=ts"

import "./YonrinHeader.vue?vue&type=style&index=0&id=5edeee74&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edeee74"]])

export default __exports__